import React from 'react';
import {
  Box,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Text,
  Heading,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  FormHelperText,
} from '@chakra-ui/react';

const CONSENT_MESSAGE = `I consent to receive text messages from the Rotary Club at the mobile number provided. I understand that message and data rates may apply, and I can opt out at any time by replying STOP to any message received.`;

const ViewConsentForm = () => {
  return (
    <Box maxW="800px" mx="auto" p={8}>
      <VStack spacing={8} align="stretch">
        <Alert status="info" variant="subtle" flexDirection="column" alignItems="center" justifyContent="center" textAlign="center" borderRadius="lg">
          <AlertIcon boxSize="40px" mr={0} />
          <AlertTitle mt={4} mb={1} fontSize="lg">
            Consent Form Preview
          </AlertTitle>
          <AlertDescription maxWidth="sm">
            This is how the consent form appears to members when they access it. The form below is in view-only mode.
          </AlertDescription>
        </Alert>

        <Box p={8} borderWidth={1} borderRadius="lg" boxShadow="lg">
          <VStack spacing={6} align="stretch">
            <Heading size="md" textAlign="center" color="primary.500">
              Text Message Consent Form
            </Heading>

            <Text fontSize="sm" color="gray.600">
              Please review our consent form format below. Members must complete this form to receive text messages.
            </Text>

            <FormControl>
              <FormLabel>Full Name</FormLabel>
              <Input
                placeholder="Enter your full name, with first and last name"
                isReadOnly
                bg="gray.50"
              />
            </FormControl>

            <FormControl>
              <FormLabel>Phone Number</FormLabel>
              <Input
                placeholder="(000) 000-0000"
                isReadOnly
                bg="gray.50"
              />
              <FormHelperText>
                Enter the phone number that was registered with the Rotary Club shown in your consent email.
              </FormHelperText>
            </FormControl>

            <Box p={4} bg="gray.50" borderRadius="md">
              <Text fontWeight="medium" mb={2}>
                Consent Message:
              </Text>
              <Text>
                {CONSENT_MESSAGE}
              </Text>
              <FormHelperText mt={2}>
                You must click the checkbox to consent to receive text messages from the club.
              </FormHelperText>
            </Box>

            <Alert status="success" variant="left-accent">
              <AlertIcon />
              <Box>
                <AlertTitle>After Submission:</AlertTitle>
                <AlertDescription>
                  Members receive a confirmation text message and must reply YES to activate their consent.
                </AlertDescription>
              </Box>
            </Alert>

            <Box bg="gray.50" p={4} borderRadius="md">
              <Text fontSize="sm" color="gray.600">
                <strong>Note:</strong> When members submit this form, we automatically:
                <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                  <li>Record their IP address</li>
                  <li>Store their consent in the audit history</li>
                  <li>Update their member status</li>
                  <li>Send a confirmation text</li>
                </ul>
              </Text>
            </Box>
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};

export default ViewConsentForm;
